import Modal from './Modal.vue';
export default {
  components: {
    Modal: Modal
  },
  props: {
    title: {},
    text: {}
  },
  emits: ['confirm'],
  data: function data() {
    return {
      tag: null
    };
  },
  methods: {
    open: function open(tag) {
      this.tag = tag;
      this.$refs.dlg.open();
    },
    confirm: function confirm() {
      this.$refs.dlg.close();
      this.$emit('confirm', true);
    },
    cancel: function cancel() {
      this.$refs.dlg.close();
      this.$emit('confirm', false);
    }
  }
};